/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Input,
  Tooltip,
  Upload,
} from 'antd';
import { useChangeHandler } from 'hooks';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { promotionsCleanUp } from 'state/actions/promotion';
import { regexInput } from 'utils/regex';
import { imgUrl } from 'utils/url';
import { log } from 'utils';
import { ExportIcon } from 'assets/icon/dynamic';
import './DealForm.css';
import './DealForm.scss';

const DealForm = ({ deal, setDeal, success, action, id, history, error }) => {
  const { siteId, siteName } = useParams();
  log(error);

  const [isDragged, setIsDragged] = useState(false);
  const [errors, setErrors] = useState(error);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const { loading, userData } = useSelector(
    (state) => ({
      loading: state.promotions.loading,
      userData: state.auth.userData,
    }),
    shallowEqual
  );

  const uid = userData.id;

  const dispatch = useDispatch();

  useEffect(() => {
    if (success) {
      history.push(`/${siteId}/information/${siteName}`);
    }
  }, [success]); // eslint-disable-line

  useEffect(() => {
    return () => dispatch(promotionsCleanUp());
  }, [dispatch]);

  const onChangeHandler = useChangeHandler(setDeal);

  const onFileChangedHandler = (file) => {
    setDeal((prevState) => ({ ...prevState, file, thumbnail: null }));
  };

  const handleDeletePreviewImage = () => {
    setDeal((prevState) => ({
      ...prevState,
      file: null,
      thumbnail: null,
      featuredImage: null,
    }));
  };

  const onSubmitHandler = (value) => {
    log(deal);
    value.preventDefault();

    const title = deal.title || deal.Title;
    if (!regexInput(title) && title) {
      const newErrors = {
        ...errors,
        errors: {
          ...errors.errors,
        },
        message: 'Something went wrong!',
      };

      newErrors.errors.title = !regexInput(title) &&
        title && [
          {
            msg: 'This field cannot contain any special characters',
          },
        ];

      setErrors(newErrors);
    } else {
      log(deal, 'deal');
      dispatch(
        action({
          uid,
          ...deal,
          title: deal.title || deal.Title,
          siteId,
          id,
        })
      );
    }
  };

  const existingImageUrl = deal.featuredImage?.sourceUrl;
  const imagePreviewUrl = deal.file
    ? URL.createObjectURL(deal.file)
    : existingImageUrl
      ? `${imgUrl}/deals/${existingImageUrl}`
      : null;

  return (
    <div className="deal-form">
      <form className="form-wrapper">
        <div>
          <div className="form">
            <label className="form-label">
              Name <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Deal Name"
              className={`${
                errors && errors.errors && errors.errors.title ? 'has-error' : ''
              }`}
              name="title"
              value={deal.title || deal.Title || ''}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.title && (
              <span className="error-message">{errors.errors.title[0].msg}</span>
            )}
          </div>


          <div className="form">
            <label className="form-label">Description</label>
            <Input.TextArea
              rows={5}
              placeholder="Deal Description"
              className={`${
                errors && errors.errors && errors.errors.description
                  ? 'has-error'
                  : ''
              }`}
              name="description"
              value={deal.description || ''}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.description && (
              <span className="error-message">
                {errors.errors.description[0].msg}
              </span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Link URL</label>
            <Input
              placeholder="https://example.com/deal"
              className={`${
                errors && errors.errors && errors.errors.link
                  ? 'has-error'
                  : ''
              }`}
              name="link"
              value={deal.link || ''}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.link && (
              <span className="error-message">
                {errors.errors.link[0].msg}
              </span>
            )}
          </div>
        </div>
        <div>
          <div className="form">
            <label className="form-label">Image</label>
            {imagePreviewUrl ? (
              <div className="upload-image-preview">
                <Tooltip placement="top" title="Delete">
                  <button
                    type="button"
                    onClick={handleDeletePreviewImage}
                    className="btn-remove"
                  >
                    <i className="feather-x" />
                  </button>
                </Tooltip>
                <img
                  className="media-avatar"
                  src={imagePreviewUrl}
                  alt="User profile logo preview"
                />
              </div>
            ) : (
              <Upload
                accept="image/*"
                showUploadList={false}
                beforeUpload={onFileChangedHandler}
              >
                <div
                  onDragLeave={() => setIsDragged(false)}
                  onDragOver={() => setIsDragged(true)}
                  className={`upload-drag-and-drop ${
                    isDragged ? 'active' : ''
                  }`}
                >
                  <ExportIcon size={22} color="#C2C2C2" />
                  <p className="upload-title">
                    Drag or <span className="upload-highlight">Browse</span>
                  </p>
                  <p className="upload-subtitle">
                    File format supported: jpg, png (Up to 5MB){' '}
                  </p>
                </div>
              </Upload>
            )}
          </div>
        </div>
      </form>
      <div
        className="button-wrapper"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <div>
          {loading ? (
            <button className="button-primary" disabled>
              Loading...
            </button>
          ) : (
            <button className="btn-primary" onClick={onSubmitHandler}>
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DealForm;
